import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPageFlip = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 19.25c-4 0-7.25-2-7.25-2V5.75s3.75 1 7.25 1zm0 0c4 0 7.25-2 7.25-2V5.75"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 6.75c2.5 0 4.25-2 4.25-2V17S14.5 19 12 19"
    />
  </svg>
);
export default SvgPageFlip;
